
import * as api from "../constant/NewAPI";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import Select from "react-select";
import * as XLSX from "xlsx";
import { all_routes } from "../router/all_routes";
import Utils from "../constant/Utils";

// import * as api from "../constant/API";

const instituteReport = () => {

    const routes = all_routes;

    const userId = localStorage.getItem('UserId');
    const roleId = localStorage.getItem('RoleId');

    const [searchInput, setSearchInput] = useState('');
    const [instituteList, setInstituteList] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [reportList, setReportList] = useState([]);
    const [groupId, setGroupId] = useState('');
    const [institutionId, setInstitutionId] = useState('');
    const [showTable, setShowTable] = useState(false);
    const [linkClicked, setLinkClicked] = useState(false);

    useEffect(() => {
        instituteTypeList()
    }, [])

    function instituteTypeList() {
        const instTypeList = api.InstituteTypeList + '/' + roleId //"?userId=" + userId + "&roleId=" + roleId;
        fetch(instTypeList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((typResponse) => typResponse.json())
            .then((typResult) => {
                if (typResult.error == true) {
                    if (typResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (typResult.data != null) {
                        setGroupList(typResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log('Failed to fetch Institute Type List', error);
            })
    }

    function getInstitutes(grpId) {
        const institute = api.GetReportInstitutions + '/' + roleId + '/' + grpId //+ "?institutionTypeId=" + grpId + "&userId=" + userId + "&roleId=" + roleId;
        fetch(institute, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((instReponse) => instReponse.json())
            .then((instResult) => {
                if (instResult.error == true) {
                    if (instResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (instResult.data != null) {
                        setInstituteList(instResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch institution list", error)
            })
    }

    function statusReport() {
        const statReport = api.GetInstituteDetails + '/' + groupId + '/' + institutionId //+ "?instName=" + institutionId + "&instTypeId=" + groupId;
        fetch(statReport, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((statResponse) => statResponse.json())
            .then((statResult) => {
                if (statResult.error == true) {
                    if (statResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (statResult.data != null) {
                        setReportList(statResult.data);
                    }

                    setShowTable(true)
                    setLinkClicked(true)
                }
            })
            .catch((error) => {
                console.log('Failed to fetch status report.', error)
            })
    }

    const filteredData = reportList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const instituteRender = (rowData, column) => {
        return <span>{rowData.institutionName}</span>
    };

    const groupRender = (rowData, column) => {
        return <span>{rowData.GroupName}</span>;
    };

    const contactRender = (rowData, column) => {
        return <span>{rowData.institutionContactName}</span>
    };

    const phoneRender = (rowData, column) => {
        return <span>{rowData.institutionContactPhone}</span>;
    };

    const mailRender = (rowData, column) => {
        return <span>{rowData.institutionEmail}</span>
    };

    const addressRender = (rowData, column) => {
        return <span>{rowData.institutionAddress}</span>;
    };

    const managerRender = (rowData, column) => {
        return <span>{rowData.opsManager}</span>
    };

    const headRender = (rowData, column) => {
        return <span>{rowData.BusinessHead}</span>;
    };

    const userNameRender = (rowData, column) => {
        return <span>{rowData.institutionUsername}</span>
    };

    const passwordRender = (rowData, column) => {
        return <span>{rowData.institutionPassword}</span>
    }

    const exportToExcel = () => {
        const formData = new FormData();
        formData.append('instTypeId', groupId)
        formData.append('instName', institutionId)
        const exportExcel = api.InstituteReportExport;
        fetch(exportExcel, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((exportReponse) => exportReponse.json())
            .then((exportResult) => {
                if (exportResult.error == true) {
                    if (exportResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    const blob = new Blob([exportResult.data], { type: "application/vnd.ms-excel" });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "Institute Report.xls"; // Save file as .xls
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                }
            })
            .catch((error) => {
                console.log("Failed to export Institute Report", error);
            })
    }

    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h3 className="text-center mb-40">
                                    <i className="fa fa-university"></i>
                                    Institute Report
                                </h3>
                            </div>
                            <div>
                                <Link
                                    to={routes.reports}
                                    className="btn btn-secondary save-profile"
                                >
                                    <i className="fas fa-arrow-left"></i>Back
                                </Link>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="court-tab-content">
                                        <div className="court-tab-content">
                                            <div className="card card-tableset">
                                                <div className="card-body">
                                                    <div className="coache-head-blk">
                                                        <div className="row align-items-center">
                                                            <div className="row col-md-12">
                                                                <div className="row col-md-12 court-sortby sortbyset">
                                                                    <div className="col-md-4">
                                                                        <div className="mb-10">
                                                                            <label className="sortbytitle"><h6>Institute Group</h6></label>
                                                                            <Select
                                                                                value={groupList.find(grp => grp.institutionGroupId === groupId) ? {
                                                                                    value: groupId,
                                                                                    label: groupList.find(grp => grp.institutionGroupId === groupId).institutionGroupName
                                                                                } : null}
                                                                                onChange={(e) => {
                                                                                    setGroupId(e.value);
                                                                                    getInstitutes(e.value)
                                                                                }}
                                                                                options={groupList.map(grp => ({
                                                                                    value: grp.institutionGroupId,
                                                                                    label: grp.institutionGroupName
                                                                                }))}>
                                                                            </Select>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <div className="mb-10">
                                                                            <label className="sortbytitle"><h6>Institute</h6></label>
                                                                            <Select value={instituteList.find(inst => inst.institutionId === institutionId) ? {
                                                                                value: institutionId,
                                                                                label: instituteList.find(inst => inst.institutionId === institutionId).institutionName
                                                                            } : null}
                                                                                onChange={(e) => {
                                                                                    setInstitutionId(e.value)
                                                                                }}
                                                                                options={instituteList.map(inst => ({
                                                                                    value: inst.institutionId,
                                                                                    label: inst.institutionName
                                                                                }))}
                                                                                placeholder={"Select Institute"}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="row col-md-12">
                                                                        <div className="save-changes text-sm-end mt-2">
                                                                            <Link
                                                                                to="#"
                                                                                className="btn btn-secondary save-profile"
                                                                                onClick={statusReport}
                                                                            >
                                                                                Submit
                                                                            </Link>
                                                                            <Link
                                                                                to="#"
                                                                                className='btn btn-secondary save-profile'
                                                                                onClick={exportToExcel}
                                                                            >
                                                                                Export to Excel
                                                                            </Link>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-12 border-bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }} />
                                                                    {showTable && (
                                                                        <>
                                                                            <div className="col-md-12">
                                                                            </div>
                                                                            <div className="col-md-12">
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                                <div className="dataTables_filter">
                                                                                    <label>
                                                                                        <input
                                                                                            type="text"
                                                                                            value={searchInput}
                                                                                            onChange={(e) => setSearchInput(e.target.value)}
                                                                                            placeholder="Search"
                                                                                            className="form-control"
                                                                                        />
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            {showTable && (
                                                                <>
                                                                    <div className="tab-content">
                                                                        <div
                                                                            className="tab-pane fade show active"
                                                                            id="nav-Recent"
                                                                            role="tabpanel"
                                                                            aria-labelledby="nav-Recent-tab"
                                                                            tabIndex={0}
                                                                        >
                                                                            <div className="table-responsive table-datatble">
                                                                                <DataTable
                                                                                    className="table datatable"
                                                                                    value={filteredData}
                                                                                    paginator
                                                                                    rows={10}
                                                                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                                                                    // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                                                    pageLinkSize={3}
                                                                                >
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="slNo"
                                                                                        body={slNoRender}
                                                                                        header="Sl No"
                                                                                        headerStyle={{ backgroundColor: "#0f2a4e", color: "#FFFF" }}
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="institutionName"
                                                                                        body={instituteRender}
                                                                                        header="Institute"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="GroupName"
                                                                                        body={groupRender}
                                                                                        header="Group"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="institutionContactName"
                                                                                        body={contactRender}
                                                                                        header="Contact"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="institutionContactName"
                                                                                        body={phoneRender}
                                                                                        header="Phone"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="institutionEmail"
                                                                                        body={mailRender}
                                                                                        header="Email"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="institutionAddress"
                                                                                        body={addressRender}
                                                                                        header="Address"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="opsManager"
                                                                                        body={managerRender}
                                                                                        header="Ops Manager"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="BusinessHead"
                                                                                        body={headRender}
                                                                                        header="Business Head"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="institutionUsername"
                                                                                        body={userNameRender}
                                                                                        header="User Name"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="institutionPassword"
                                                                                        body={passwordRender}
                                                                                        header="Password"
                                                                                    ></Column>
                                                                                </DataTable>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
};

export default instituteReport;